import React, { useState } from 'react';
import { 
  FaUserMd, 
  FaGraduationCap, 
  FaHospital, 
  FaAward, 
  FaClock, 
  FaMapMarkerAlt, 
  FaPhone, 
  FaStethoscope,
  FaHeart,
  FaBriefcaseMedical,
  FaLanguage,
  FaCheck,
  FaUsers,
  FaCalendarAlt
} from 'react-icons/fa';

const BestUrologistSection = () => {
  const [imageError, setImageError] = useState(false);

  return (
    <section className="py-12 md:py-16 bg-gradient-to-br from-blue-50 to-white">
      <div className="container mx-auto px-4">
        
        <div className="text-center mb-5">
          <h2 className="text-3xl font-bold text-gray-800 mb-3">
           Best Urologist  <span className="text-sky-600"> in Ranchi</span>
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-sky-500 to-red-500 mx-auto rounded-full"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            
            <div className="lg:w-5/12 p-6 md:p-8">
              <div className="relative">
                <div className="relative mx-auto w-60 h-60 md:w-72 md:h-72 rounded-full overflow-hidden border-8 border-white shadow-xl">
                  {imageError ? (
                    <div className="w-full h-full bg-gradient-to-br from-sky-400 to-red-400 flex flex-col items-center justify-center p-4">
                      <FaUserMd className="text-white text-5xl mb-3" />
                      <div className="text-white text-2xl font-bold">Dr. Shukla</div>
                      <div className="text-white/90 text-sm mt-1">MBBS, MS, MCh</div>
                      <div className="text-white/80 text-xs">Urologist</div>
                    </div>
                  ) : (
                    <img
                      src="image.png"
                      alt="Dr. Shailendra Mohan Shukla"
                      className="w-full h-full object-cover"
                      onError={() => setImageError(true)}
                      onLoad={() => setImageError(false)}
                      loading="lazy"
                    />
                  )}
                </div>
              </div>

              <div className="mt-6 space-y-4">
                
                {/* Experience and Patients Stats - NEW ADDITION */}
                <div className="grid grid-cols-2 gap-3">
                  <div className="bg-gradient-to-br from-sky-50 to-sky-100 rounded-xl p-4 text-center border border-sky-200">
                    <div className="flex flex-col items-center">
                      <FaCalendarAlt className="text-sky-600 text-xl mb-2" />
                      <div className="text-2xl font-bold text-gray-800">10+</div>
                      <div className="text-xs font-semibold text-gray-600">Years Experience</div>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-4 text-center border border-red-200">
                    <div className="flex flex-col items-center">
                      <FaUsers className="text-red-600 text-xl mb-2" />
                      <div className="text-2xl font-bold text-gray-800">10000+</div>
                      <div className="text-xs font-semibold text-gray-600">Patients Treated</div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-4 shadow-sm border border-sky-100">
                  <h4 className="text-md font-bold text-gray-800 mb-3 flex items-center">
                    <FaGraduationCap className="text-red-500 mr-2" />
                    Medical Credentials
                  </h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Degree</span>
                      <span className="font-semibold text-sky-600">MBBS, MS, MCh</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Specialization</span>
                      <span className="font-semibold text-sky-600">Urology</span>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-sky-50 to-red-50 rounded-lg p-4">
                  <div className="flex items-center">
                    <FaClock className="text-red-500 mr-3" />
                    <div>
                      <div className="font-bold text-gray-800 text-sm">Clinic Hours</div>
                      <div className="text-gray-600 text-xs">Mon-Sat: 9AM-7PM</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:w-7/12 p-6 md:p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Dr. Shailendra Mohan Shukla
              </h3>
              
              {/* Alternative placement option - You can also place stats here if preferred */}
              <div className="flex flex-wrap gap-3 mb-4">
                <div className="inline-flex items-center bg-sky-100 text-sky-800 px-3 py-1 rounded-full text-sm font-semibold">
                  <FaCalendarAlt className="mr-1 text-sm" /> 10+ Years Experience
                </div>
                <div className="inline-flex items-center bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-semibold">
                  <FaUsers className="mr-1 text-sm" /> 10000+ Patients Treated
                </div>
              </div>

              <div className="mb-6 p-4 bg-gradient-to-r from-sky-50 to-red-50 rounded-lg border-l-4 border-sky-500">
                <div className="flex items-start">
                  <FaHospital className="text-red-500 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <p className="text-gray-700 font-medium">
                      MBBS, MS, MCh (यूरोलॉजी)
                    </p>
                    <p className="text-gray-600 text-sm mt-1">
                      Govt. Medical College, त्रिवेंद्रम (केरल)
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <p className="text-gray-700 text-sm leading-relaxed mb-4">
                  Dr. Shailendra Mohan Shukla is one of the most trusted and renowned Urologists in Ranchi, dedicated to delivering advanced and compassionate urological care. With over <span className="font-semibold text-sky-600">10+ years of experience</span> and having successfully treated <span className="font-semibold text-red-600">more than 10,000 patients</span>, he brings extensive expertise in diagnosing and treating a wide range of urological conditions.
                </p>
                <p className="text-gray-700 text-sm leading-relaxed">
                  At our clinic, we specialize in the treatment of kidney stones, prostate disorders, urinary tract infections, male infertility, and other urological issues. Dr. Shukla combines the latest technology with a patient-centric approach to ensure accurate diagnosis, minimally invasive procedures, and speedy recovery.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
                  <FaStethoscope className="text-sky-600 mr-2" />
                  Specialized Treatments
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {[
                    'Kidney Stones Treatment',
                    'Prostate Disorders',
                    'Urinary Tract Infections',
                    'Male Infertility',
                    'Urological Cancers',
                    'Minimally Invasive Surgery'
                  ].map((treatment, index) => (
                    <div key={index} className="flex items-center group">
                      <FaCheck className="text-red-500 text-xs mr-2 group-hover:scale-125 transition-transform" />
                      <span className="text-gray-700 text-sm group-hover:text-sky-600 transition-colors">{treatment}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 mb-6">
                <a
                  href="https://www.sarthaks.com/?qa=blob&qa_blobid=11896422458397334978"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 px-4 py-3 bg-gradient-to-r from-sky-500 to-red-500 text-white font-semibold rounded-lg hover:from-sky-600 hover:to-red-600 transition-all duration-300 transform hover:scale-105 text-center flex items-center justify-center"
                >
                  <FaBriefcaseMedical className="mr-2" />
                  Know More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestUrologistSection;